import React, {useState} from 'react';
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import {IWatotoCareSettings} from 'app/shared/model/watotocare-settings-model';
import {fromCents, toCents, toPercent, validateCentsString} from 'app/shared/util/money-utils';
import {useTranslation} from 'app/shared/util/translation-utils';

interface IOverrideModalProps {
  opened: boolean;
  toggle: () => void;
  defaultAmount: number;
  paymentRequestedPrice: number;
  onSave: (number) => void;
  settings: IWatotoCareSettings
}

const OverridePriceModal = ({
                              opened,
                              toggle,
                              onSave,
                              defaultAmount,
                              paymentRequestedPrice,
                              settings
                            }: IOverrideModalProps) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<number>(defaultAmount);
  const [amountValid, setAmountValid] = useState(true);

  const calculateMaxAmount = (): number => {
    // defaultAmount was already converted from cents e.g. 12301 -> 123.01; set back to 12301
    const amountInCents = toCents(paymentRequestedPrice);
    const maxAmount = Math.floor(amountInCents + (amountInCents * toPercent(settings.paymentEditThreshold)));
    return fromCents(maxAmount);
  }

  const onAmountChange = (e) => {
    const {target} = e;
    setAmount(target.value);
    setAmountValid(validateCentsString(target.value) && target.value > 0 && target.value <= calculateMaxAmount());
    console.log("amount valid: {}", (amount > 0));
    console.log("amount less than max: {}", (amount < calculateMaxAmount()));
  }

  const onSubmit = () => {
    onSave(amount);
    toggle();
  }

  return (
    <Modal isOpen={opened} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t('payment.modal.overridePrice')}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="new-amount">{t('payment.modal.currentPrice')}: {defaultAmount} {settings.currencySymbol ? settings.currencySymbol : 'LSL'}</Label>
            <br />
            <Label for="requested-price">{t('payment.modal.requestedPrice')}: {paymentRequestedPrice} {settings.currencySymbol ? settings.currencySymbol : 'LSL'}</Label>
            <br />
            <Label for="new-amount">{t('payment.modal.newPrice')}:</Label>
            <Input
              onChange={onAmountChange}
              value={amount}
              name="number"
              type="number"
              min={0}
              max={calculateMaxAmount()}
              id="new-amount"
              valid={amountValid}
              invalid={!amountValid}
              required
            />
            <FormFeedback tooltip>{t('payment.modal.amountValidation')}</FormFeedback>
            <FormText>
              {t('payment.modal.maxAmount', { 
                maxAmount: calculateMaxAmount().toFixed(2), 
                requestedAmount: paymentRequestedPrice.toFixed(2) 
              })}
            </FormText>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>{t('common.actions.cancel')}</Button>{' '}
        <Button color="primary" onClick={onSubmit} disabled={!amountValid}>{t('common.actions.save')}</Button>
      </ModalFooter>
    </Modal>
  );
}

export default OverridePriceModal;
